import 'angular:locale/data:fr';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "fr";
